import { List, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { formatCellValue, rowDrillTarget } from "../rowsFormat"
import { neutral } from "../tokens"
import type { RowRecord, RowsPayload } from "../types"

interface RowCardListProps {
  data: RowsPayload
  currency?: string
  pageSize?: number
  onOpen?: (target: string) => void
}

export const RowCardList = ({
  data,
  currency,
  pageSize,
  onOpen
}: RowCardListProps) => {
  const { i18n } = useTranslation()
  const [primaryCol, ...restCols] = data.columns

  const secondaryOf = (row: RowRecord) =>
    restCols
      .map(
        (col) =>
          `${col.title}: ${formatCellValue(row[col.key], col.unit, {
            currency,
            language: i18n.language
          })}`
      )
      .join(" · ")

  return (
    <List
      size="small"
      data-testid="row-card-list"
      dataSource={data.rows}
      pagination={pageSize ? { pageSize, hideOnSinglePage: true } : false}
      rowKey={(row) =>
        String((row as { id?: unknown }).id ?? row[primaryCol?.key ?? ""])
      }
      renderItem={(row) => {
        const target = rowDrillTarget(row)
        const secondary = secondaryOf(row)
        return (
          <List.Item
            style={target ? { cursor: "pointer" } : undefined}
            onClick={target && onOpen ? () => onOpen(target) : undefined}
          >
            <div
              style={{ display: "flex", flexDirection: "column", minWidth: 0 }}
            >
              <Typography.Text>
                {formatCellValue(
                  primaryCol ? row[primaryCol.key] : undefined,
                  primaryCol?.unit,
                  {
                    currency,
                    language: i18n.language
                  }
                )}
              </Typography.Text>
              {secondary && (
                <Typography.Text style={{ fontSize: 12, color: neutral.muted }}>
                  {secondary}
                </Typography.Text>
              )}
            </div>
          </List.Item>
        )
      }}
    />
  )
}
